import { SourceType } from '@debbie/common/dist/cosmo/events/index.js';
import { ProviderName } from '@debbie/common/dist/cosmoV2/providers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { errorNotification } from '../../../utils/errors.js';
import Badge from '../../Badge.js';
import Clock from '../../Icons/Clock.js';
import Edit from '../../Icons/Edit.js';
import Input from '../../Input.js';
import Modal from '../../Modal.js';
import PerformedBy from '../../performed-by/PerformedBy.js';
const UserInfoEntity = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [histOpen, setHistOpen] = useState(false);
    const [value, setValue] = useState(props.value);
    useEffect(() => {
        if (!editing) {
            setValue(props.value);
        }
    }, [props.value]);
    useEffect(() => {
        document.addEventListener('keydown', onEscapePress);
        return () => document.removeEventListener('keydown', onEscapePress);
    }, []);
    const onEscapePress = (evt) => {
        const event = evt || window.event;
        if (event.code === 'Escape') {
            if (editing) {
                setValue(props.value);
                toggleEdit();
            }
        }
        else if (event.code === 'Enter' && !props.renderEditor && editing) {
            save(value);
        }
    };
    const toggleHist = () => setHistOpen(!histOpen);
    const toggleEdit = () => setEditing(!editing);
    const save = async (value) => {
        try {
            setLoading(true);
            props.onChange && (await props.onChange(value));
        }
        catch (err) {
            console.error(err);
            errorNotification(lang, err, 'update', props.title);
        }
        setLoading(false);
        setEditing(false);
    };
    const remove = async () => {
        try {
            setLoading(true);
            props.onChange && (await props.onChange(null));
        }
        catch (err) {
            console.error(err);
            errorNotification(lang, err, 'delete', props.title);
        }
        setValue(null);
        setLoading(false);
        setEditing(false);
    };
    return (React.createElement(UserInfoEntityStyled, null,
        React.createElement("h3", null,
            props.title,
            props.tags &&
                props.tags.map((tag) => (React.createElement("div", { "data-tooltip-id": tag.tooltip ? 'tooltip-default' : undefined, "data-tooltip-content": tag.tooltip, style: {
                        display: 'inline-block',
                    } },
                    React.createElement(Badge, { style: {
                            verticalAlign: 'middle',
                            marginLeft: '.7em',
                            fontSize: '.7em',
                        }, theme: tag.theme || THEME.COLOR_ACCENT }, tag.content)))),
            React.createElement("div", { style: { float: 'right' } },
                props.nextToInfo,
                props.hist && (React.createElement(Clock, { style: { cursor: 'pointer' }, onClick: toggleHist })),
                props.onChange && site === Site.Caseworker && (React.createElement(Edit, { style: { cursor: 'pointer', marginLeft: '5px' }, onClick: toggleEdit }))),
            histOpen && (React.createElement(Modal, { maxWidth: "300px", header: `${props.title} History`, onToggle: toggleHist },
                React.createElement("h2", { style: { fontSize: '1.2em' } }, props.renderValue ? props.renderValue(props.value) : props.value),
                props.hist ? (React.createElement("div", null,
                    React.createElement("h3", { style: {
                            textTransform: 'uppercase',
                            fontSize: '0.9em',
                            color: '#4a4a4a',
                        } }, lang.debtorInfo.previous),
                    React.createElement("div", null,
                        React.createElement(EventHist, { events: props.hist, renderValue: props.renderValue })))) : (React.createElement("p", null, lang.debtorInfo.noPreviousToShow))))),
        editing ? (props.renderEditor ? (props.renderEditor((selectedValue) => {
            save(selectedValue);
            setValue(selectedValue);
        })) : (React.createElement("div", null,
            React.createElement(Input, { autofocus: true, style: { marginBottom: '0' }, value: value, onChange: (e) => {
                    setValue(e.target.value);
                }, placeholder: props.title, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        save(value);
                    }
                }, button: value !== props.value
                    ? {
                        loading: loading,
                        onClick: () => save(value),
                        value: lang.inputs.save,
                        disabled: props.validate && !props.validate(value),
                    }
                    : props.removable
                        ? {
                            loading: loading,
                            onClick: remove,
                            value: lang.inputs.remove,
                        }
                        : undefined })))) : props.renderValue ? (props.renderValue(value)) : (value || React.createElement("span", { style: { opacity: 0.5 } }, props.title))));
};
export default UserInfoEntity;
const EventHist = (props) => {
    return (React.createElement("div", null, props.events.map((cosmoEvent) => {
        return (React.createElement(ListItem, { key: cosmoEvent.cosmoEventId },
            React.createElement("h4", null,
                props.renderValue
                    ? props.renderValue(cosmoEvent.value)
                    : cosmoEvent.value,
                React.createElement("span", { style: { float: 'right' } }, cosmoEvent.createdBy &&
                    (cosmoEvent.source === SourceType.USER ||
                        cosmoEvent.source === ProviderName.DEBBIE ||
                        cosmoEvent.source === ProviderName.LEGACY) ? (React.createElement(PerformedBy, { performedBy: cosmoEvent.createdBy })) : (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, cosmoEvent.source === ProviderName.LEGACY
                    ? 'Cosmo'
                    : cosmoEvent.source)))),
            React.createElement("p", null, cosmoEvent.createdAt &&
                moment(cosmoEvent.createdAt).format(THEME.DATE_FORMAT_LONG))));
    })));
};
const ListItem = styled.div `
  padding: 10px 0;
  font-size: 0.9em;
  border-bottom: 1px solid ${THEME.BORDER_STRONG};

  &:last-child {
    border-bottom: none;
  }

  p {
    font-size: 0.7em;
    margin-top: 0.3em;
    opacity: 0.6;
    font-weight: bold;
  }

  p,
  h4 {
    margin: 0;
  }
`;
const UserInfoEntityStyled = styled.div `
  padding-bottom: ${THEME.GRID_SPACING}px;
`;
//# sourceMappingURL=UserInfoEntity.js.map